import { combineReducers } from 'redux';
import { establishment, menu, map } from "./Reducers";

export default combineReducers({
    establishment,
    menu,
    map
});